import React, { useContext } from 'react';
import classnames from 'classnames';
import { Columns } from 'ui-base';
import { Aside } from './Aside';
import { ProductListingPageContext } from '../context';
import styles from './Aside.module.scss';

const AsideColumn = () => {
  const { isMobile } = useContext(ProductListingPageContext);
  return isMobile ? null : (
    <Columns.Column
      tablet={{ size: 'one-quarter' }}
      desktop={{ size: 'one-fifth' }}
      className={classnames('aside-column', styles.column)}
    >
      <Aside />
    </Columns.Column>
  );
};

export { AsideColumn };
